var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backStoryContainer"},[_c('Presentational',{attrs:{"backStory":_vm.backStory},on:{"open":function($event){return _vm.$emit('modalOpen')},"update":function (backStory) {
        _vm.updateBackStory(backStory);
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }